// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2o5h7","errorLogs":"EditorFooter_errorLogs__1MR55"};